import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
const OffsetWrapper = props => {
  const {
    children,
    offsetBottom,
    offsetTop,
    className,
    style
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: _extends({
      height: '100%',
      paddingBottom: offsetBottom,
      paddingTop: offsetTop,
      boxSizing: 'border-box'
    }, style)
  }, children);
};
export default OffsetWrapper;